import { faDna, faPencilSquare, faUser } from "@fortawesome/free-solid-svg-icons";


export const environment = {
  appVersion: 1.0,
  production: false,
  backendUrl: 'https://csem.difesa.it/genomica/api',
  //backendUrl: 'https://genomica.we-com.info/api',
  hugoLink: 'https://www.genenames.org/data/gene-symbol-report/#!/hgnc_id/',
  pharmaKgb:'https://api.pharmgkb.org/v1/',
  betterResourceUrl: 'https://csem.difesa.it/ehr/rest/v1',
  geneUrl: 'https://cors-anywhere.herokuapp.com/https://pubchem.ncbi.nlm.nih.gov/rest/pug/gene/genesymbol/{geneSymbol}/summary/JSON',
  forms: [
    {
      name: 'Richiesta_Sequenziamento_DNA',
      version: '1.0.42',
      icona: faDna,
      url: '/richiesta-sequenziamento',
      colore: 'blue',
      submit: true,
      ruolo: "MEDICO"
    },
    {
      name: 'Sequenziamento_DNA',
      version: '1.0.8',
      icona: faDna,
      url: '/sequenziamento',
      colore: 'blue',
      submit: false,
      ruolo: "MEDICO"
    },
    
    {
      name: 'Analisi_Cariotipo',
      version: '1.0.8',
      icona: faDna,
      url: '/pazienti',
      colore: 'blue',
      submit: false,
      ruolo: "GENETISTA"
    }, {
      name: 'Richiesta_Cariotipo',
      version: '1.0.5',
      icona: faDna,
      url: '/richiesta-cariotipo',
      colore: 'blue',
      submit: true,
      ruolo: "MEDICO"
    },
    {
      name: 'Stato Richieste',
      icona: faPencilSquare,
      url: '/pazienti',
      colore: 'blue',
      submit: false,
      ruolo: "GENETISTA"
    },
    {
      name: 'Anamnesi',
      icona: faUser,
      url: '/pazienti',
      colore: 'blue',
      submit: false,
      ruolo: "GENETISTA"
    }
  ],
  keycloak: {
    url: 'https://csem.difesa.it/iam/',
    realm: 'fascicolo_sanitario',
    clientId: 'medical_care_front',
    redirectUrl: window.location.origin + '/genomica/assets/silent-check-sso.html'

  },
  context: {
    language: 'it',
    readonly: false,
    presentationMode: false,
    showAllPages: false,
    dateFormat: 'dd/MM/yyyy',

  },
  betterContextReadonly: {
    language: 'it',
    readonly: true,
    territory:'IT',
    presentationMode: true,
    theme:'white',
    dateFormat: 'dd/MM/yyyy',
  },
  credentials: {
    authType: 'oauth2',
    token: ''
  },
  informazioniPersonali:{
    name: 'Informazioni personali',
    version: '1.0.390',
    submit: true,
  },allergieMedicazioni:{
    name:'Allergie e Medicazioni',
    version:'1.0.255',
    submit:true
  }
};

